var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotizToolAktiv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Notiz-Tool-Aktiv__Icn/40px/Notiz-Tool-Aktiv",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Notiz-Tool-Aktiv__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Notiz-Tool-Aktiv__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.0002857,13 L20.998,19.999 L28,20 L28,26 L20.998,25.999 L21.0002857,33 L15.0002857,33 L14.999,25.999 L8,26 L8,20 L14.999,19.999 L15.0002857,13 L21.0002857,13 Z M19,15 L17,15 L16.999,22 L10,22 L10,24 L16.999,24 L17,31 L19,31 L18.999,24 L26,24 L26,22 L18.999,22 L19,15 Z M28,2.25 C31.1909786,2.25 33.7777778,4.94394475 33.7777778,8.26709402 C33.7777778,10.3594473 32.0598994,13.4438577 28.6241427,17.5203252 L28,18.25 C24.1481481,13.8101622 22.2222222,10.4825269 22.2222222,8.26709402 C22.2222222,4.94394475 24.8090214,2.25 28,2.25 Z M28,4.25 C25.9321586,4.25 24.2222222,6.0307621 24.2222222,8.26709402 C24.2222222,9.53588176 25.3473047,11.7277352 27.6364102,14.6676089 L28,15.128 L28.3638818,14.6672339 L28.8371223,14.0480654 C30.7346633,11.5165494 31.7042682,9.59278032 31.7737532,8.40179756 L31.7777778,8.26709402 C31.7777778,6.0307621 30.0678414,4.25 28,4.25 Z M28,6.25 C29.1045695,6.25 30,7.1454305 30,8.25 C30,9.3545695 29.1045695,10.25 28,10.25 C26.8954305,10.25 26,9.3545695 26,8.25 C26,7.1454305 26.8954305,6.25 28,6.25 Z",
    id: ".._.._src_svg_Icn_40px_Notiz-Tool-Aktiv__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotizToolAktiv);
export default __webpack_public_path__ + "static/media/Notiz-Tool-Aktiv.d1c53d70722dd9b98f0d3fcc66bb72d9.svg";
export { ForwardRef as ReactComponent };